import { Observable } from "rxjs";
import HttpService from "./HttpService";
import { url } from "./APIEndPoints";
import {
  buildParamString,
  IAPICommonResponse,
  IAPIResponse,
} from "@mindmemobile/mm-shared-global";
import {
  IAPICheckoutGridModel,
  IAPICheckOutSaveUpdateModel,
  IAPIRelatedCheckoutGridModel,
} from "../interfaces/IAPICheckoutModel";
import {
  IAPICheckOutPurchaseModel,
  IAPICustomerFacingCheckOutModel,
  IAPIPaymentIntentModel,
  IAPIPurchaseCheckOutItemsModel,
} from "../interfaces/IAPIPurchaseModels";
import { IAPIPurchaseMerchantModel } from "../interfaces/IAPIMerchantModels";

class CheckOutService {
  private httpService: HttpService;
  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_API_BASE_URL
    );
  }

  getGridData(
    accountId: string,
    pageNumber: number,
    pageSize: number,
    searchValue: string
  ): Observable<IAPIResponse<IAPICheckoutGridModel[]>> {
    const params: string = buildParamString({
      accountId: accountId,
      pageNumber: pageNumber,
      pageSize: pageSize,
      searchValue: searchValue,
    });

    return this.httpService.get<IAPIResponse<IAPICheckoutGridModel[]>>(
      url.getCheckoutGridData,
      params
    );
  }

  getCheckoutRelatedGridData(
    accountId: string,
    itemType: string,
    itemId: string
  ): Observable<IAPIResponse<IAPIRelatedCheckoutGridModel[]>> {
    const params: string = buildParamString({
      accountId: accountId,
      itemType: itemType,
      itemId: itemId,
    });

    return this.httpService.get<IAPIResponse<IAPIRelatedCheckoutGridModel[]>>(
      url.getCheckoutRelatedGridData,
      params
    );
  }

  getCheckOut(
    id: string,
    accountId: string
  ): Observable<IAPIResponse<IAPICheckOutSaveUpdateModel>> {
    const params: string = buildParamString({
      checkOutId: id,
      accountId: accountId,
    });

    return this.httpService.get<IAPIResponse<IAPICheckOutSaveUpdateModel>>(
      url.getCheckOut,
      params
    );
  }

  saveCheckOut(
    data: IAPICheckOutSaveUpdateModel
  ): Observable<IAPIResponse<string>> {
    return this.httpService.post<IAPIResponse<string>>(url.saveCheckOut, data);
  }

  updateCheckOut(
    data: IAPICheckOutSaveUpdateModel
  ): Observable<IAPIResponse<boolean>> {
    return this.httpService.put<IAPIResponse<boolean>>(
      url.updateCheckOut,
      data
    );
  }

  getCustomerFacingCheckOutDetails(
    checkOutId: string,
    searchValue: string = ""
  ): Observable<IAPIResponse<IAPICustomerFacingCheckOutModel>> {
    const params: string = buildParamString({
      checkOutId: checkOutId,
      searchValue: searchValue,
    });

    return this.httpService.get<IAPIResponse<IAPICustomerFacingCheckOutModel>>(
      url.getCustomerFacingCheckOut,
      params
    );
  }

  createPaymentIntent(
    source: string,
    accountId: string,
    sourceId?: string | null,
    merchantAccount?: IAPIPurchaseMerchantModel
  ): Observable<IAPIResponse<IAPIPaymentIntentModel>> {
    const request = {
      sourceId: sourceId,
      source: source,
      accountId: accountId,
      merchantAccount: merchantAccount || null,
    };
    return this.httpService.post<IAPIResponse<IAPIPaymentIntentModel>>(
      url.createPaymentIntent,
      request
    );
  }

  purchaseCheckOutItems(
    request: IAPICheckOutPurchaseModel
  ): Observable<IAPIResponse<IAPIPurchaseCheckOutItemsModel>> {
    return this.httpService.post<IAPIResponse<IAPIPurchaseCheckOutItemsModel>>(
      url.purchaseCheckOutItems,
      request
    );
  }

  updateStatus(
    accountId: string,
    id: string,
    isActive: boolean
  ): Observable<IAPIResponse<boolean>> {
    const request = {
      accountId: accountId,
      id: id,
      isActive: isActive,
    };

    return this.httpService.put<IAPIResponse<boolean>>(
      url.checkOutStatusUpdate,
      request
    );
  }

  deleteCheckout(
    accountId: string,
    checkoutId: string
  ): Observable<IAPIResponse<IAPICommonResponse>> {
    const request = {
      accountId: accountId,
      checkOutId: checkoutId,
    };
    return this.httpService.put<IAPIResponse<IAPICommonResponse>>(
      url.deleteCheckout,
      request
    );
  }
}
export default new CheckOutService();
